import { createInjectionState } from '@vueuse/core'
import $ from 'jquery'
import { computed, ref } from 'vue'

const [useProvideVideoShow, _useVideoShow] = createInjectionState(() => {
  const playerRef = ref(null)
  const quickConversationRef = ref(null)
  const isQuickConversationModal = computed(() => {
    if (!quickConversationRef.value) {
      return false
    }
    return $(quickConversationRef.value.$el).is('[data-slot="quick-conversation-modal"]')
  })

  return {
    quickConversationRef,
    isQuickConversationModal,
    playerRef,
  }
})

function useVideoShow() {
  return _useVideoShow() ?? {
    quickConversationRef: ref(null),
  }
}

export {
  useProvideVideoShow,
  useVideoShow,
}
